<template>
  <sl-side-panel :destroyOnClose="true" v-model="visible" :mask-closable="false" title="车辆详情" :loading="loading">
    <div slot="header">
      <sl-more v-if="isAC && actions.length" @click="handleActions" :data="actions"><Button type="default" ghost>更多操作</Button></sl-more>
    </div>
    <Tabs value="t1">
      <TabPane v-permission="'car.info.detail.base'" label="车辆信息" name="t1" class="label-position-top">
        <Row type="flex" align="middle">
          <Col span="12">
          <CellGroup>
            <Cell :title="data.carStateDisplay" label="车辆状态">
              <Icon size="32" slot="icon" type="md-speedometer" />
            </Cell>
            <Cell label="快递员">
              {{data.courier.name || 'N/A'}}
              <Icon size="32" slot="icon" type="md-contact" />
              <Button v-permission="'car.info.detail.base.bind'" v-if="data.courier.id && isAC" type="primary" slot="extra" @click="handleUnbind">解绑</Button>
              <Button v-permission="'car.info.detail.base.bind'" v-if="!data.courier.id && isAC" type="primary" slot="extra" @click="handleBind">绑定</Button>

            </Cell>
            <Cell label="账户余额">
              {{balance || 'N/A'}}
              <Icon slot="icon" size="32" custom="i-icon icon-financial" />
              <div slot="extra">
                <Button v-permission="'car.info.charge'" v-if="isAC" type="primary" @click="handleAddfunds">充值</Button>
                <Button v-permission="'car.info.detail.base.deduct'" style="margin-left:5px;" v-if="isAdmin && shouldLock" type="primary" @click="handleLockForCredit">{{this.data.effectState == 0 ? '欠费锁定' : '欠费解锁'}}</Button>
              </div>
            </Cell>
            <Cell :title="data.billingStateText" label="计费状态">
              <Icon size="32" slot="icon" custom="i-icon icon-jifei" />
              <i-switch v-if="isAdmin" slot="extra"  :loading="billingLoading" v-model="data.billingStateNP" @on-change="handleBillingToggle">
              </i-switch>
            </Cell>
            <Cell :title="data.lockStateDisplay" label="锁定状态">
              <Icon size="32" slot="icon" type="ios-lock" />
              <i-switch v-if="isAC" slot="extra" :loading="lockLoading" v-model="data.lockState" @on-change="handleLockToggle" :true-value="1" :false-value="0" />
            </Cell>
          </CellGroup>
          </Col>
          <Col span="12" style="text-align: center">
          <img :src="data.qrcode">
          </Col>
        </Row>
        <Divider />
        <sl-detail-list v-if="this.$a('car.info.detail.base.detail')" layout="vertical" :col="4" label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="车辆类型" :content="data.category.name" />
          <sl-detail-list-item title="车牌号" :content="data.license.licenseNo" />
          <sl-detail-list-item title="当前所属企业" :content="data.company.companyName" />
          <sl-detail-list-item title="登记时间" :content="data.enrollDatetimeText" />
          <sl-detail-list-item title="车辆编号" :content="data.carNo" />
          <sl-detail-list-item title="车辆品牌" :content="data.brand" />
          <sl-detail-list-item title="IMEI" :content="data.imei" />
          <sl-detail-list-item title="车架号" :content="data.frameNo" />
          <sl-detail-list-item title="电池规格" :content="data.battery.specs" />
          <sl-detail-list-item title="电机号" :content="data.motorNo" />
          <sl-detail-list-item title="电池序号" :content="data.battery.batteryNo" />
          <sl-detail-list-item title="电池品牌" :content="data.battery.brand" />
          <sl-detail-list-item title="电池类型" :content="data.battery.typeText" />
          <sl-detail-list-item title="保险公司" :content="data.insurance.insuranceCompanyName" />
          <sl-detail-list-item title="保单号" :content="data.insurance.insuranceNo" />
          <sl-detail-list-item title="保险生效时间" :content="data.insurance.startDatetimeText" />
          <sl-detail-list-item title="保险到期时间" :content="data.insurance.endDatetimeText" />

          <sl-detail-list-item title="购车方案" :content="data.buyOptionsText" />
          
          <sl-detail-list-item v-if="data.buyOptions == 1" title="金融公司" :content="data.billing.companyName" />
          <sl-detail-list-item v-if="data.buyOptions == 1" title="结算周期" :content="data.billing.clearingTypeText" />
          <sl-detail-list-item v-if="data.buyOptions == 1" title="每期价格" :content="data.billing.stagesPrice" />
          <sl-detail-list-item v-if="data.buyOptions == 1" title="开始计费时间" :content="data.billing.startDatetimeText" />
          <sl-detail-list-item v-if="data.buyOptions == 1" title="最近扣费时间" :content="data.lastBindRecordDisplay" />
          <sl-detail-list-item v-if="data.buyOptions == 1" title="已扣期数/总期数">{{data.billing.stagesNum-data.billing.repayStagesNum}}/{{data.billing.stagesNum}}</sl-detail-list-item>
          <sl-detail-list-item v-if="data.buyOptions == 1"title="已扣金额/总金额">{{(data.billing.totalAmount-data.billing.repayAmount).toFixed(2)}}/{{data.billing.totalAmount}}</sl-detail-list-item>

          <sl-detail-list-item title="合格证编号" :content="data.certNo" />
          <sl-detail-list-item title="一致性证书" :content="data.cocNo" />
          <sl-detail-list-item title="颜色" :content="data.color" />
        </sl-detail-list>
        <sl-detail-list layout="vertical" :col="1" label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="照片">
            <sl-carousel :images="data.photo ? data.photo.split(';') : []" />
          </sl-detail-list-item>
          <sl-detail-list-item title="备注" :content="data.remark" />
        </sl-detail-list>
      </TabPane>
      <TabPane v-if="$a('car.info.detail.charge')" label="费用明细">
        <car-bill :car-id="id" />
      </TabPane>
      <TabPane v-if="$a('car.info.detail.use')" label="使用记录">
        <car-log-lite :car-no="carNo" />
      </TabPane>
      <TabPane v-if="$a('car.info.detail.billing')" label="扣款记录">
        <car-invoice :car-id="id" />
      </TabPane>
      <TabPane v-if="$a('car.info.detail.update')" label="更新记录">
        <car-change-log :car-no="carNo" />
      </TabPane>
      
    </Tabs>
  </sl-side-panel>
</template>
<script>
import payment from '../../billing/payment'
import carLogLite from '../partial/logLite'
import carBill from '../partial/bill'
import carInvoice from '../partial/invoice'
import carBind from '../partial/bind'
import carChangeLog from '../partial/change-log'
import { carStateDisplay, billingRuleDisplay, lastBindRecordDisplay , lockStateDisplay } from '../partial/utils'
import funcMixins from '../partial/mixins'
import global from '@/util/mixin/global'
import QRCode from 'qrcode'

export default {
  components: { carLogLite, carBill, payment , carInvoice , carStateDisplay , carChangeLog },
  mixins: [funcMixins,global],
  data() {
    return {
      id: null,
      carNo: null,
      loading: false,
      data: { category: {}, battery: {}, billing: {}, insurance: {}, company: {}, courier: {}, license: {},lastLockRecord:{} },
      visible: false,
      lockLoading:false,
      billingLoading:false,
      api:{
        cars:'cars',
        carImportUrl:'carImportUrl',
        remove:'carDelete',
        enable:'carEnable',
        turn:'carTurn',
        lock:'carLock',
      }
    }
  },

  computed: {
    actions() {
      let acts = []
      if(this.$a('car.info.detail.start')){
        acts.push({ value: 'turn', label: this.data.startState == 1 ? '停止' : '启动' })
      }
      if( this.isAdmin && this.$a('car.info.detail.enable') ){
        acts.push({ value: 'enable', label: this.data.enableState == 1 ? '禁用' : '启用' })
      }
      return acts
    },
    itemTitle() {
      return this.carNo ? '编辑车辆' : '新增车辆'
    },
    balance() {
      let d = parseFloat(this.data.billing.balance)
      let label = isNaN(d) ? 'n/a' : `￥${d}`

      if(!isNaN(d)  && d < 0){
        label += this.data.effectState == 1 ? '（欠费已锁）' : '（欠费未锁）'
      }
      return label
    },
    qrcode2() {
      return `https://www.kuaizhan.com/common/encode-png?large=true&data=${encodeURIComponent(this.data.imei)}`
    },
    shouldLock(){
      let d = this.data.billing.balance;
      return isNaN(parseFloat(d)) === false && d < 0
    },
    enableStateTitle() {
      switch (this.data.enableState) {
        case 1:
          return '启用';
        case 0:
          return '未启用';
        case 2:
          return '禁用';
        default:
          return 'N/A'

      }
    },

    lockEnable() {

    }
  },
  created() {
    this.def = { ...this.form }
  },
  watch:{
    lockState(v){

    }
  },

  methods: {

    init(id) {
      this.carNo = id
      // this.reset()
      this.visible = true
      if (this.carNo) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.car(this.carNo).then(resp => {
        this.loading = false
        if (resp.code == 0) {

          this.id = resp.data.id
          this.carNo = resp.data.carNo
          resp.data.billingState = resp.data.billing ? resp.data.billing.state : 0
          this.$utils.valid(resp.data, {
            courier: {},
            billing: {},
            company: {},
            battery: {},
            category: {},
            insurance: {},
            license: {},
            lastLockRecord:{}
          })
          this.$utils.conv(resp.data, {
            enrollDatetime: 'datetime',
            buyOptions: 'buyOptions',
            billingState: 'billingState',
            lockState: 'carLockState',
            driveState: 'driveState',
            enableState: 'carEnableState',
            billingStateNP: d => (d.billingState == 1),
            enableStateNP: d => (d.enableState == 1),
          })

          this.$utils.conv(resp.data.lastLockRecord, {
            lockerType: 'carLockerType',
          })

          this.$utils.conv(resp.data, {
            carStateDisplay,
            billingRuleDisplay,
            lastBindRecordDisplay,
            lockStateDisplay
          })

          this.$utils.conv(resp.data.billing, {
            clearingType: 'clearingType',
            startDatetime: 'datetime',
            nextDatetime: 'datetime'
          })

          this.$utils.conv(resp.data.battery, {
            type: 'batteryType',
          })

          this.$utils.conv(resp.data.insurance, {
            startDatetime: 'date',
            endDatetime: 'date',
          })
          
          this.data = resp.data

          QRCode.toString(resp.data.imei, {
            margin: 0,
            width: 200,
            height: 200,
            color: {
              light: '#0000' // Transparent background
            }
          }, (err, data) => {
            if (err) throw err

            this.data.qrcode = 'data:image/svg+xml;base64,' + btoa(data)
            // this.saveToImage()
          })
          console.log(this.data)

        } else {
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })

    },

    reset() {
      this.data = { category: {}, battery: {}, billing: {}, insurance: {}, company: {}, courier: {}, license: {} , lastLockRecord:{} }
    },
    handleAddfunds() {
      // this.$refs['payment'].init(this.data.id)
      this.$dialog({
        component:payment , 
        title:'车辆充值',
        width:450,
        paddingless:true,
        render:(h)=>{
          return h(payment , {
            props:{id:this.data.id , carNo : this.data.carNo}
          })
        },
        onOk:()=>{
          this.query()
        }
      })
    },
    handleBillingToggle(flag) {
      let tip = flag ? '开始计费' : '停止计费'

      this.billingLoading = true
      this.$ui.confirm(this.$request.carBillingEnable, `确定${tip}？`)(this.data.id, flag).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('操作成功')
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
          this.data.billingStateNP = !flag
        }
        this.billingLoading = false
        this.query()
      } , ()=>{
        this.billingLoading = false
        this.data.billingStateNP = !flag
      })
    },
    handleLockToggle(flag) {
      let tip = flag ? '锁定' : '解锁'
      let params = { carNo: this.data.carNo, lockState: flag == 1 ? 1 : 0 }
      this.lockLoading = true
      this.$ui.confirm(this.$request.carLock, `确定${tip} ${this.data.carNo} ？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
          this.data.lockState = flag == 1 ? 0 : 1
        }
        this.lockLoading = false
        this.query()
      } , ()=>{
        this.lockLoading = false
        this.data.lockState = flag == 1 ? 0 : 1
      })
    },
    handleUnbind() {
      this.$ui.confirm(this.$request.carUnbind, `确定解绑 ${this.data.carNo} ？`)(this.data.carNo).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('操作成功')
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
        this.query()
      })
    },
    handleBind() {
      this.$dialog({
        title:'快递员绑定',
        width:450,
        className:'paddingless',
        render:(h)=>{
          return h(carBind , {
            props:{companyId:this.data.companyId , carNo:this.data.carNo }
          })
        },
        onOk:()=>{
          this.query()
        }
      })
    },

    handleUpdate() {
      this.query()
    },
    handleActions(evt){
      this.handleMoreActions(evt , this.data)
    },

    //欠费锁定
    handleLockForCredit(){
      let currentState = this.data.effectState
      let tip = currentState == 0 ? '锁定' : '解锁'
      let params = { carNo: this.data.carNo, effectState: currentState == 0 ? 1 : 0 }
      this.$ui.confirm(this.$request.carLockForCredit, `确定${tip} ${this.data.carNo} ？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
        this.query()
      } , ()=>{
      })
    }
  }
}

</script>
<style>
</style>
